import { Grid, Menu, Select, TextField, MenuItem, FormControlLabel, Switch, Button } from '@mui/material'
import React, { useState } from 'react'

const EMPTY_GROUP = {
  season: null,
  coaches: [],
  class: null,
  participants: [],
  notes: '',
  state: 'active', // active, inactive
  maxparticipants: 0,
  level: null,
  callinInUse: false,
  replacementInUse: false,
  resourceId: null,
  tags: [],
  reservationid: null,
}

const MANDATORY_FIELDS = ['season', 'class']

function CoachingGroup({ clubclasses = [], seasons = [], clubcoaches = [], levels = [], onSave, onDelete, group, resourceid, reservationid, starttime, endtime }) 
{
  let newGroup = false
  if (!group) {
    newGroup = true
  }
  // const [name, setName] = useState('')
  // const [season, setSeason] = useState(null)
  // const [coaches, setCoaches] = useState([])
  // const [gclass, setGclass] = useState(null)
  // const [participants, setParticipants] = useState([])
  // const [notes, setNotes] = useState([])
  // const [state, setState] = useState('active') // active, inactive
  // const [maxparticipants, setMaxParticipants] = useState(0)
  // const [level, setLevel] = useState(null) 
  // const [callinInUse, setCallinInUse] = useState(false)
  // const [replacementInUse, setReplacementInUse] = useState(false)
  // const [resourceId, setResourceId] = useState(null)
  // const [tags, setTags] = useState([])
  // const [reservationid, setReservationid] = useState(null)
  const [groupData, setGroupData] = useState(group || { ...EMPTY_GROUP, resourceId: resourceid || null, reservationid: reservationid || null, starttime: starttime || null, endtime: endtime || null })
  const [changed, setChanged] = useState(false)
  const [saving, setSaving] = useState(false)

  const onChange = (field, value) => {
    setChanged(true)
    setGroupData({
      ...groupData,
      [field]: value,
    })
  }

  const storeGroup = async () => {
    if (onSave) {
      setSaving(true)
      onSave(groupData).then(() => {
        setChanged(false)
        setSaving(false)
      }).catch(() => {
        setSaving(false)
      })
    }
  }


  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Group Name"
            placeholder={newGroup ? "New Coaching Group" : ""}
            value={groupData.name}
            onChange={(e) => onChange('name', e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Select onChange={(e) => onChange('season', e.target.value)} value={groupData.season} fullWidth>
            <MenuItem value="">Select Season</MenuItem>
            {seasons.map((s) => (
              <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Select onChange={(e) => onChange('class', e.target.value)} value={groupData.class} fullWidth>
            <MenuItem value="">Select Class</MenuItem>
            {clubclasses.map((c) => (
              <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Select onChange={(e) => onChange('level', e.target.value)} value={groupData.level} fullWidth>
            <MenuItem value="">Select Level</MenuItem>
            {levels.map((l) => (
              <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Select
            multiple
            onChange={(e) => onChange('coaches', Array.from(e.target.selectedOptions, (option) => option.value))}
            value={groupData.coaches}
            fullWidth
          >
            {clubcoaches.map((coach) => (
              <MenuItem key={coach.id} value={coach.id}>{coach.name}</MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Max Participants"
            type="number"
            value={groupData.maxparticipants}
            onChange={(e) => onChange('maxparticipants', parseInt(e.target.value, 10))}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Resource ID"
            value={groupData.resourceId}
            onChange={(e) => onChange('resourceId', e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Reservation ID"
            value={groupData.reservationid}
            onChange={(e) => onChange('reservationid', e.target.value)}
            fullWidth
          />
        </Grid> 
        <Grid item xs={12} sm={6}>
          <Select
            multiple
            onChange={(e) => onChange('tags', Array.from(e.target.selectedOptions, (option) => option.value))}
            value={groupData.tags}
            fullWidth
          >
            {/* Example tags */}
            <MenuItem value="morning">Morning</MenuItem>
            <MenuItem value="evening">Evening</MenuItem>
            <MenuItem value="weekend">Weekend</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Select
            value={groupData.state}
            onChange={(e) => onChange('state', e.target.value)}
            fullWidth
          >
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
        control={
          <Switch
            checked={groupData.callinInUse}
            onChange={(e) => onChange('callinInUse', e.target.checked)}
            name="callinInUse"
            color="primary"
          />
        }
        label="Call-in In Use"
      />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Switch
                checked={groupData.replacementInUse}
                onChange={(e) => onChange('replacementInUse', e.target.checked)}
                name="replacementInUse"
                color="primary"
              />
            }
            label="Replacement In Use"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Notes"
            value={groupData.notes}
            onChange={(e) => onChange('notes', e.target.value)}
            fullWidth
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Participants (comma separated IDs)"
            value={groupData.participants}
            onChange={(e) => onChange('participants', e.target.value.split(',').map((id) => id.trim()))}
            fullWidth
            multiline
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" onClick={storeGroup} disabled={!changed || saving || MANDATORY_FIELDS.some((field) => !groupData[field])}>
            {saving ? 'Saving...' : 'Save Group'}
          </Button>
          {!newGroup && onDelete && (
            <Button variant="contained" color="secondary" onClick={() => onDelete(groupData)} style={{ marginLeft: 10 }}>
              Delete Group
            </Button>
          )}
        </Grid>
      </Grid>
    </div>
  )
}

export default CoachingGroup
  